import React from 'react'


function BlogPost({imageLink, blogLink, title}) {
    return (
        <div className="blogpost" onClick={() => window.location.href = blogLink}>
            <img src={imageLink}></img>
            <h2>{title}</h2>
        </div>
    )
}

export default BlogPost
